export { default } from './FullWidthSection'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/FullWidthSection/index.js